import { useState } from "react";
import { Form } from "../../rent-reporting-onboarding/components/Form";
import { DropZone } from "common/DropZone";
import api from "api";
import { toast } from "react-toastify";
import { useMutation } from "@tanstack/react-query";
import { PostPageView } from "helpers/postEvent";
import { View } from "../types";

const uploadFile = (uploadUrl: string, fileObj: File) => {
  return fetch(uploadUrl, {
    method: "PUT",
    body: fileObj,
    mode: "cors"
  });
};

export const FileUploadSlice = ({
  setView,
  handleIssueUpload
}: {
  handleIssueUpload: ({
    url,
    filename,
    description
  }: {
    url: string;
    filename: string;
    description: string;
  }) => Promise<void>;
  setView: (view: View) => void;
}) => {
  const [files, setFiles] = useState<File[]>([]);

  const uploadFiles = useMutation({
    mutationKey: ["uploadFiles"],
    mutationFn: () =>
      Promise.all(
        files.map((file) =>
          api
            .createPresignedUrlLeaseUpload({ filename: file.name })
            .then(({ data }) => data)
            .then(({ presigned_url }) => uploadFile(presigned_url, file))
            .then(({ url }) => {
              handleIssueUpload({
                url,
                filename: file.name,
                description: "Document uploaded by user"
              });
            })
        )
      ),
    onError: (error) => {
      toast.error(error.message || "An error occurred");
    },
    onSuccess: () => {
      setView(View.SelectTransactionView);
    }
  });

  return (
    <Form
      onBack={() => {
        setView(View.SelectTransactionView);
      }}
      isSubmitDisabled={uploadFiles.isPending || files.length === 0}
      isSubmitLoading={uploadFiles.isPending}
      onSubmit={(e: { preventDefault: () => void }) => {
        e.preventDefault();
        uploadFiles.mutate();
      }}
      formId="upload-lease"
    >
      <PostPageView />
      <h1 className="text-xl font-bold text-content-1000 mb-4">
        Attach documents
      </h1>
      <p className="text-content-600 text-sm mb-6">
        You can verify your rent payment that was made by another method (e.g.
        cash, money order) by adding photos of original receipts or screenshots.
        This acceptable for the occasional months, but not several months in a
        row. Please allow at least 2 business days for processing.
      </p>

      <DropZone id="lease" value={files} setValue={setFiles} />
    </Form>
  );
};
